import ContractSignatureConsentModal from './component';
import { ContractSignatureConsentModalProps } from './types';

export default ContractSignatureConsentModal;
export type { ContractSignatureConsentModalProps };
